import * as types from '../../constants/actionTypes';

// Opening pages: What to expect, Who is the request for?, Has the patient
// been seen at CC recently?
export function webAppointmentAcknowledgedWhatToExpect(value) { // boolean param.
  return { type: types.WEBAPPOINTMENT_ACKNOWLEDGED_WHAT_TO_EXPECT, value };
}
export function webAppointmentSetForMe(value) { // boolean
  return { type: types.WEBAPPOINTMENT_SET_WHO_FOR, value };
}
export function webAppointmentSetPatientSeenRecently(value) { // boolean param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_SEEN_RECENTLY, value };
}

// Proxy/Contact Info
export function webAppointmentSetContactOver18(value) { // boolean param.
  return { type: types.WEBAPPOINTMENT_SET_CONTACT_OVER_18, value };
}
export function webAppointmentSetContactRelation(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_CONTACT_RELATION, value };
}
export function webAppointmentSetContactFirstName(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_CONTACT_FIRST_NAME, value };
}
export function webAppointmentSetContactLastName(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_CONTACT_LAST_NAME, value };
}
export function webAppointmentSetContactEmail(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_CONTACT_EMAIL, value };
}
export function webAppointmentSetContactPhone(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_CONTACT_PHONE, value };
}

// Patient Info
export function webAppointmentSetPatientFirstName(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_FIRST_NAME, value };
}
export function webAppointmentSetPatientLastName(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_LAST_NAME, value };
}
export function webAppointmentSetPatientGender(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_GENDER, value };
}
export function webAppointmentSetPatientMaritalStatus(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_MARITAL_STATUS, value };
}
export function webAppointmentSetPatientDob(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_DOB, value };
}
export function webAppointmentSetPatientSsn(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_SSN, value };
}

// Patient Contact Info
export function webAppointmentSetPatientAddress1(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_ADDRESS1, value };
}
export function webAppointmentSetPatientAddress2(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_ADDRESS2, value };
}
export function webAppointmentSetPatientCity(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_CITY, value };
}
export function webAppointmentSetPatientState(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_STATE, value };
}
export function webAppointmentSetPatientZip(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_ZIP, value };
}
export function webAppointmentSetPatientEmail(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_EMAIL, value };
}
export function webAppointmentSetPatientPhone(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_PHONE, value };
}
export function webAppointmentSetPatientMrn(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_PATIENT_MRN, value };
}

// Appointment Info
export function webAppointmentSetAppointmentReason(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_REASON, value };
}
export function webAppointmentSetAppointmentDiagnosis(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_DIAGNOSIS, value };
}
export function webAppointmentSetAppointmentProvider(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_PROVIDER, value };
}
export function webAppointmentSetAppointmentDepartment(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_DEPARTMENT, value };
}
export function webAppointmentSetAppointmentLocation(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_LOCATION, value };
}
export function webAppointmentSetAppointmentType(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_TYPE, value };
}
export function webAppointmentSetAppointmentDay(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_DAY, value };
}
export function webAppointmentSetAppointmentTime(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_TIME, value };
}
export function webAppointmentSetAppointmentReferringPhysFName(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_REFERRING_FNAME, value };
}
export function webAppointmentSetAppointmentReferringPhysLName(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_REFERRING_LNAME, value };
}
export function webAppointmentSetAppointmentReferringPhysPhone(value) { // string param.
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_REFERRING_PHONE, value };
}
export function webAppointmentSetAppointmentHaveReferringPhys(value) { // bool
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_HAVE_REFERRING_PHYS, value };
}
export function webAppointmentSetAppointmentNeedServices(value) { // bool
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_NEED_SERVICES, value };
}
export function webAppointmentSetAppointmentWhichService(value) { // 'yes', 'no'
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_WHICH_SERVICE, value };
}
export function webAppointmentSetAppointmentForeignLanguage(value) { // 'yes', 'no'
  return { type: types.WEBAPPOINTMENT_SET_APPOINTMENT_FOREIGN_LANGUAGE, value };
}

// Billing and Insurance
export function webAppointmentSetPaymentMethod(value) { // 'yes', 'no'
  return { type: types.WEBAPPOINTMENT_SET_PAYMENT_METHOD, value };
}
export function webAppointmentSetInsuranceCompany(value) {
  return { type: types.WEBAPPOINTMENT_SET_INSURANCE_COMPANY, value };
}
export function webAppointmentSetInsurancePolicyNumber(value) {
  return { type: types.WEBAPPOINTMENT_SET_INSURANCE_POLICY_NUMBER, value };
}
export function webAppointmentSetInsurancePolicyType(value) {
  return { type: types.WEBAPPOINTMENT_SET_INSURANCE_POLICY_TYPE, value };
}
export function webAppointmentSetInsuranceGroup(value) {
  return { type: types.WEBAPPOINTMENT_SET_INSURANCE_GROUP, value };
}
export function webAppointmentSetInsuranceWhereToSend(value) {
  return { type: types.WEBAPPOINTMENT_SET_INSURANCE_WHERE_TO_SEND, value };
}

export function webAppointmentSetInsuranceHolderRelation(value) {
  return { type: types.WEBAPPOINTMENT_SET_INSURANCE_HOLDER_RELATION, value };
}
export function webAppointmentSetInsuranceHolderFname(value) {
  return { type: types.WEBAPPOINTMENT_SET_INSURANCE_HOLDER_FNAME, value };
}
export function webAppointmentSetInsuranceHolderLname(value) {
  return { type: types.WEBAPPOINTMENT_SET_INSURANCE_HOLDER_LNAME, value };
}
export function webAppointmentSetInsuranceHolderDob(value) {
  return { type: types.WEBAPPOINTMENT_SET_INSURANCE_HOLDER_DOB, value };
}
export function webAppointmentSetInsuranceHolderEmail(value) {
  return { type: types.WEBAPPOINTMENT_SET_INSURANCE_HOLDER_EMAIL, value };
}

// Billing info and address
export function webAppointmentSetBillingRelation(value) {
  return { type: types.WEBAPPOINTMENT_SET_BILLING_RELATION, value };
}
export function webAppointmentSetBillingFirstName(value) {
  return { type: types.WEBAPPOINTMENT_SET_BILLING_FNAME, value };
}
export function webAppointmentSetBillingLastName(value) {
  return { type: types.WEBAPPOINTMENT_SET_BILLING_LNAME, value };
}
export function webAppointmentSetBillingDob(value) {
  return { type: types.WEBAPPOINTMENT_SET_BILLING_DOB, value };
}
export function webAppointmentSetBillingAddress1(value) {
  return { type: types.WEBAPPOINTMENT_SET_BILLING_ADDRESS1, value };
}
export function webAppointmentSetBillingAddress2(value) {
  return { type: types.WEBAPPOINTMENT_SET_BILLING_ADDRESS2, value };
}
export function webAppointmentSetBillingCity(value) {
  return { type: types.WEBAPPOINTMENT_SET_BILLING_CITY, value };
}
export function webAppointmentSetBillingState(value) {
  return { type: types.WEBAPPOINTMENT_SET_BILLING_STATE, value };
}
export function webAppointmentSetBillingZip(value) {
  return { type: types.WEBAPPOINTMENT_SET_BILLING_ZIP, value };
}

// Scheduling PFA Callback.
export function webAppointmentPfaCallbackWindowDismissed(value) {
  return { type: types.WEBAPPOINTMENT_SET_PFA_CALLBACK_WINDOW_DISMISSED, value };
}

// Finally requesting the appointment
export function webAppointmentSetRequestResults(value) {
  return { type: types.WEBAPPOINTMENT_SET_REQUEST_RESULTS, value };
}

export function webAppointmentClearOutData() {
  return { type: types.WEBAPPOINTMENT_CLEAR_OUT_DATA, value: null };
}
